import { Input } from 'reactstrap'
import { NumericFormat } from 'react-number-format'
import SearchFormSelect from './SearchFormSelect'
import SearchFormYesNo from './SearchFormYesNo'
import { FIELD_TYPE } from '../../constants.js'

export default function SearchFormInput(props) {
  const { index, field, onChangeFunction, defaultValue } = props
  console.log('SearchFormInput rendered: ', field.name, props)
  
  let inputElement
  const className = 'search-form-input'

  switch (parseInt(field.type.id)) {
    case FIELD_TYPE.objectId:
    case FIELD_TYPE.integer:
      inputElement = <Input index={index} type="number" bsSize="sm" step="1" pattern="\d+" data-cy="search-form-integer" name="inputValue" className={className} onChange={onChangeFunction} defaultValue={defaultValue} />
      break
    case FIELD_TYPE.number:
      inputElement = <Input index={index} type="number" bsSize="sm" data-cy="search-form-number" name="inputValue" className={className} onChange={onChangeFunction} defaultValue={defaultValue} />
      break
    case FIELD_TYPE.currency:
      inputElement = 
        <NumericFormat
          index={index}
          data-cy="search-form-currency"
          name="inputValue"
          className={className}
          displayType={'input'}
          thousandSeparator={true}
          decimalScale={2}
          fixedDecimalScale={true}
          onChange={onChangeFunction}
          defaultValue={defaultValue[0]}
        />
      break
    case FIELD_TYPE.shortText:
    case FIELD_TYPE.multilineText:
    case FIELD_TYPE.file:
      inputElement = <Input index={index} type="text" bsSize="sm" data-cy="search-form-file" name="inputValue" className={className} onChange={onChangeFunction} defaultValue={defaultValue} />
      break
    case FIELD_TYPE.date:
      inputElement = <Input index={index} type="date" max="2999-01-01" data-cy="search-form-date" name="inputValue" className={className} onChange={onChangeFunction} defaultValue={defaultValue} />
      break
    case FIELD_TYPE.yesNo:
      const yesNoDefault = defaultValue.length > 0 ? defaultValue[0] : null
      inputElement = <SearchFormYesNo index={index} onChangeFunction={onChangeFunction} defaultValue={yesNoDefault} />
      break
    case FIELD_TYPE.objectState:
    case FIELD_TYPE.select:
    case FIELD_TYPE.multiSelect:
    case FIELD_TYPE.objectOwner:
    case FIELD_TYPE.objectType:
      inputElement = <SearchFormSelect index={index} field={field} onChangeFunction={onChangeFunction} defaultValue={defaultValue} />
      break
    default:
      inputElement = <Input index={index} type="text" name="inputValue" className={className} onChange={onChangeFunction} defaultValue={defaultValue} />
  }

  return inputElement
}